<div class="goal-header" [appResponsiveGauge]="gaugeConfig">
    <div class="goal-title-col">
        <div class="goal-title text-alt1">{{ goal.name }}</div>
        <div class="group-goal-field" *ngIf="goal.groupGoal">
            <div class="group-goal-text">{{ 'GOAL_VIEW.RELATED_TEAM_GOAL' | translate }}</div>
            <div>
                <strong>{{ goal.groupGoal.employeeName }}:</strong> {{ goal.groupGoal.name }}
            </div>
        </div>
    </div>
    <div *ngIf="hasIndicators" class="indicators">
            <ngx-gauge #itemGauge type="full" [ngClass]="{'no-value': panelResult === null }"
                    [value]="panelResult | number: '1.0-0'" 
                    [size]="93" 
                    label=""
                    [thick]="5"
                    foregroundColor="#17A5E3"
                    append="%">
            </ngx-gauge>
    
            <div class="weight-indicator">
                <app-weight-indicator [weight]="panelWeight ? panelWeight : null" [size]="62"></app-weight-indicator>
            </div>
    </div>
    <div class="goal-buttons">
        <button [routerLink]="['/goal-edit', goal.id]" mat-flat-button class="button-bg-alt1 edit-button" [disabled]="!allowEdit()" (click)="onEdit()" [innerHtml]="'GOAL_VIEW.EDIT_EVALUATION' | translate"></button>
        <!-- <button mat-icon-button color="primary" class="goal-delete hidden-print icon-button" [disabled]="!allowDelete()" (click)="onDelete()" title="Törlés">
            <mat-icon>delete</mat-icon>
        </button> -->
    </div>
</div>

<div class="goal-actions" *ngIf="goal.actions && goal.actions.length > 0">
    <div *ngFor="let action of goal.actions; let i = index" class="goal-action">
        <div class="goal-action-fields">
            <div class="action-name">{{ action.name }}</div>
            <div class="deadline">
                <ng-container>
                    <div class="field-block-title">{{ 'GOAL_VIEW.DEADLINE' | translate }}</div>
                    <div class="field-block-value">{{ getMonthDeadline(action) }}&nbsp;</div>
                </ng-container>
            </div>
            <div class="weight-col">
                <div class="weight-indicator" *ngIf="action.weight">
                    <app-weight-indicator [weight]="action.weight" [size]="40" ></app-weight-indicator>
                </div>
            </div>
            <div class="employee-ratings">
                
                <div class="slider-labels flex-h" *ngFor="let ap of action.progress">
                    <div class="slider-text-label"><strong>{{ ap.employeeId === goalPeriod.employeeId ? ('GOAL_VIEW.SELF_ASSESSMENT' | translate) : ap.employeeName }} </strong></div>
                    <div class="slider-value-label text-alt1" [ngClass]="{'below-expectation': ap.progress && action.minExpectation && ap.progress < action.minExpectation}">
                        {{ ap.progress ? ap.progress + '%' : '-' }}
                    </div>
                </div>
            </div>

        </div>
        <div>
            <app-audit-line [data]="action"></app-audit-line>
        </div>
        <mat-expansion-panel [togglePosition]="'before'" class="no-shadow style2" *ngIf="action.comments && action.comments.length > 0">
            <mat-expansion-panel-header>
            <mat-panel-title class="text-subtitle">
                    <strong><span class="panel-title">{{ 'GOAL_VIEW.COMMENTS' | translate }}</span></strong>
                </mat-panel-title>
            </mat-expansion-panel-header> 

            <app-comment-section [config]="createCommentConfig(action)" [comments]="action.comments" 
                [isEditable]="false"
                [isShowDeleteButton]="false"
                [isAutoSave]="false"
                [singleComments]="true"
                [isCommentHeaderVisible]="true"
                displayStyle="style-3"
            ></app-comment-section>
        </mat-expansion-panel>
    </div>
</div>

<div class="goal-kpilist" *ngIf="goal.kpiList && goal.kpiList.length > 0">
    <div *ngFor="let kpi of goal.kpiList; let i = index" class="goal-action">
        <div class="goal-action-fields">
            <div class="name-col">
                <div *ngIf="hasIndicators" class="kpi-indicator">
                    <ngx-gauge type="full" [ngClass]="{'no-value': kpiResult(kpi) === null, 'alert-color': !isKpiInExpectedRange(kpi) }"
                            [value]="kpiResult(kpi) | number: '1.0-0'" 
                            [size]="62" 
                            label=""
                            [thick]="3"
                            foregroundColor="#17A5E3"
                            append="%">
                    </ngx-gauge>
                </div>
                <div class="action-name">
                    <div class="kpi-name">
                        {{ kpi.name }}
                    </div>
                    <mat-expansion-panel [togglePosition]="'before'" class="no-shadow style2" *ngIf="kpi.comments && kpi.comments.length > 0">
                        <mat-expansion-panel-header>
                        <mat-panel-title class="text-subtitle">
                                <strong><span class="panel-title">{{ 'GOAL_VIEW.COMMENTS' | translate }}</span></strong>
                            </mat-panel-title>
                        </mat-expansion-panel-header> 
    
                        <app-comment-section [config]="createCommentConfig(kpi)" [comments]="kpi.comments" 
                            [isEditable]="false"
                            [isShowDeleteButton]="false"
                            [isAutoSave]="false"
                            [singleComments]="true"
                            [isCommentHeaderVisible]="true"
                            displayStyle="style-3"
                        ></app-comment-section>
                    </mat-expansion-panel>
                </div>
            </div>
            <div class="deadline">
                <ng-container *ngIf="kpi.deadline">
                    <div class="field-block-title">{{ 'GOAL_VIEW.DEADLINE' | translate }}</div>
                    <div class="field-block-value">{{ getMonthDeadline(kpi) }}</div>
                </ng-container>
            </div>
            <div class="weight-col">
                <div class="weight-indicator" *ngIf="kpi.weight">
                    <app-weight-indicator [weight]="kpi.weight" [size]="40" ></app-weight-indicator>
                </div>
            </div>
            <div class="employee-ratings">
                
                <div class="slider-labels flex-h">
                    <div class="slider-text-label"><strong>{{ 'GOAL_VIEW.PLANNED_RESULT' | translate }}</strong></div>
                    <div class="slider-value-label text-alt1">
                        <span *ngIf="kpi.planned != null && kpi.unit">{{ kpi.planned }} {{ kpi.unit }}</span>
                        <span *ngIf="kpi.planned === null || !kpi.unit">-</span>
                    </div>
                </div>
                <div class="slider-labels flex-h">
                    <div class="slider-text-label"><strong>{{ 'GOAL_VIEW.ACHIEVED_RESULT' | translate }}</strong></div>
                    <div class="slider-value-label text-alt1" [ngClass]="{'below-expectation': !isKpiInExpectedRange(kpi)}">
                        <span *ngIf="kpi.achieved != null && kpi.unit">{{ kpi.achieved }} {{ kpi.unit }}</span>
                        <span *ngIf="kpi.achieved === null || !kpi.unit">-</span>
                    </div>
                </div>
            </div>

        </div>
        <div>
            <app-audit-line [data]="kpi"></app-audit-line>
        </div>
    </div>
</div>
